import React from "react";
import "./GetEstimate.css";
import { useWeb3Form } from "../../hooks/useWeb3Form";

const GetEstimate = () => {
  const { onSubmit, result, submitting } = useWeb3Form("footer");

  return (
    <div className="get-estimate uigrid">
      <div className="uigrid-4 cta-intro">
        <div className="cta-intro-inner">
          <h3>Get a quick estimate</h3>
          <p>
            Our time is in GMT +1. We usually respond within 3 hours. Unless
            within 9PM - 7AM
          </p>
        </div>
      </div>

      <form onSubmit={onSubmit} className="uigrid-7 estimate-form">
        <input type="checkbox" name="botcheck" className="form-botcheck" />
        <div className="estimate-form-grid">
          <div className="estimate-form-grid-2">
            <div className="estimate-form-item-holder">
              <input
                type="text"
                name="name"
                placeholder="Your Name"
                className="estimate-form-input"
                required
              />
              <div className="estimate-form-spacer"></div>
              <input
                type="email"
                name="email"
                placeholder="Your Email"
                className="estimate-form-input"
                required
              />
            </div>
          </div>
          <div className="estimate-form-grid-5">
            <div className="estimate-form-message-holder">
              <textarea
                name="message"
                placeholder="Describe your project details here..."
                className="estimate-form-text"
                rows="3"
                required
              />
              <button
                type="submit"
                className="estimate-form-submit"
                disabled={submitting}
              >
                {submitting ? "Sending..." : "Send message"}
              </button>
            </div>
          </div>
        </div>
        {result && <p className="form-status form-status--footer">{result}</p>}
      </form>
    </div>
  );
};

export default GetEstimate;
